module.exports = __webpack_public_path__ + "static/media/icon-delete-light-blue.7b1ff489.svg";